import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteEnrichmentProfile } from "./deleteEnrichmentProfile.request";

const useDeleteEnrichmentProfile = (
  options?: MutationOptions<{ ok: true }, ApiServiceError<ApiError>, string>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestDeleteEnrichmentProfile,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "enrichment"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteEnrichmentProfile;
